<div class="main-container">
    <mat-progress-bar *ngIf="loading === true" mode="indeterminate"></mat-progress-bar>
    <div class="main-brand-container brand-gradient main-font">
        <div class="flex-column">
            <div class="brand-pic-container">
                <img src="../../assets/icons/stepup-logo02-DPP 3.svg" type="image/png">
            </div>
            <span class="mat-typography">An accredited CDC diabetes prevention program.</span>
        </div>
    </div>
    <mat-tab-group class="border-radius-30" #tabGroup>
        <mat-tab label="Login">
            <ng-template matTabContent>
                    <form class="main-regular-font-dark" [formGroup]="loginFormGroup" (submit)="loginWithEmailPass()">
                        <div class="flex-column">
                            <mat-form-field appearance="outline">
                                <mat-label>Email Address</mat-label>
                                <input matInput type="text" formControlName="email" name="email" required>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Password</mat-label>
                                <input matInput type="password" formControlName="password" name="password" required>
                            </mat-form-field> 
                            <button mat-button type="button" class="align-self-start" (click)="forgotPassword()">
                                Forgot Password
                            </button>
                        </div>
                        <div class="btn-container">
                            <button mat-raised-button type="submit">
                                    LOGIN
                            </button>
                        </div>
                    </form>
            </ng-template>
        </mat-tab>
        <mat-tab label="Register"> 
                <ng-template matTabContent>
                    <form class="main-regular-font-dark" [formGroup]="registerFormGroup" (submit)="registerUser()">
                        <div class="flex-column">
                            <mat-form-field appearance="outline">
                                <mat-label>What is your name?</mat-label>
                                <input matInput type="text" name="user-name" formControlName="name" required>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>What is your email?</mat-label>
                                <input matInput name="user-email" type="email" formControlName="email" required>
                                    
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Create your password</mat-label>
                                <input matInput name="user-password" type="password" formControlName="password" required>
                            </mat-form-field>
                        </div>
                        
                        <div class="btn-container">
                            <button mat-raised-button type="submit">
                                CONTINUE
                            </button>
                        </div>
                    </form>
                </ng-template>
        </mat-tab>
    </mat-tab-group>
    <div class="quickSignin-btn-container">
        <span class="main-font">Sign In with</span>
        <div class="flex-row">
            <button mat-fab type="button" (click)="loginWithFacebook()">
                <img src="assets/icons/facebook.svg" alt="Sign in with Facebook">
            </button>
            <button mat-fab type="button" (click)="loginWithGoogleBtn()">
                <img src="assets/icons/google.svg" alt="Sign in with Google">
            </button>
        </div>
    </div>
</div>

